import { buildVisibleToolPredicate, ERainPlanTool } from '../constants';
import type { IRainAgentConfig } from '../hooks/scope';

import { SHERLOCK_TOOL_ACTIVITIES } from './activities/sherlock';
import { renderConnectionPickerCard } from './renderers/connection';
import { ESherlockInternalTool, ESherlockTool } from './sherlock';

/**
 * Behavioral config for Sherlock's chat, consumed by the Rain core hook via the
 * thread adapter.
 *
 * Sherlock surfaces its whole evidence-gathering surface because here the
 * evidence trail *is* the product: an investigator that silently traverses the
 * graph and then asserts a conclusion gives the reader no way to judge it. Each
 * call reads as a business step; `full` verbosity still shows the payloads.
 *
 * `planMarkStepToolName` is inert while `RainTodoCard` has only automation- and
 * run-scoped wrappers, so nothing renders a workspace agent's plan. It is set
 * because Sherlock enables the full `plan` source, making the refresh-on-mark
 * behavior correct as soon as a card exists.
 */
export const SHERLOCK_AGENT_CONFIG: IRainAgentConfig = {
  planMarkStepToolName: ERainPlanTool.PlanMarkStep,
  isVisibleTool: buildVisibleToolPredicate(Object.values(ESherlockTool)),
  internalTools: new Set<string>(Object.values(ESherlockInternalTool)),
  clientResolvedTools: new Set<string>([ESherlockTool.RequestConnection]),
  toolRenderers: {
    [ESherlockTool.RequestConnection]: renderConnectionPickerCard,
  },
  toolActivities: SHERLOCK_TOOL_ACTIVITIES,
};
